import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AOS from 'aos'; 
import 'aos/dist/aos.css'; 
import '../styles/stylesInformacion.css';
import EspaciosPublicos from '../componentes/EspaciosPublicos';

const Informacion = () => {
  const { hash } = useLocation();

  const [activeCard, setActiveCard] = useState(null);

  // Función para abrir/cerrar tarjetas
  const toggleCard = (index) => {
    // NUEVO: Si el ancho es mayor a 768px (Escritorio), no activamos el click.
    if (window.innerWidth > 768) return; 

    setActiveCard(activeCard === index ? null : index);
  };

  // ✅ EFECTO 1: Solo para inicializar AOS y refrescarlo cuando se abren cartas
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    // Refrescar AOS cuando cambia la tarjeta activa para recalcular alturas
    if (activeCard !== null) {
      setTimeout(() => {
        AOS.refresh();
      }, 400); 
    }
  }, [activeCard]); // <--- SOLO depende de activeCard

  // ✅ EFECTO 2: Solo para el Scroll inicial (Navegación)
  useEffect(() => {
    if (hash) {
      const elem = document.querySelector(hash);
      if (elem) {
        const isMobile = window.innerWidth < 768;
        const headerOffset = 110;
        const elementPosition = elem.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: isMobile ? 'auto' : 'smooth' 
        });
      }
    } else {
      // Si no hay hash, ir arriba. 
      // Al separarlo, esto YA NO SE EJECUTA cuando tocas una tarjeta.
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [hash]); // <--- SOLO depende del hash

  return (
    <div className="InfoMenu">
      
      <section className="seccion-conoce" id="elPueblo">
        <div className="conoce-container">
          
          <div className="intro-split">
            <div className="video-wrapper" data-aos="fade-right">
              <iframe 
                className="youtube-iframe"
                src="https://www.youtube.com/embed/Ds35KWrnf8Y" 
                title="Video Institucional Progreso" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </div>
            
            <div className="titulo-wrapper" data-aos="fade-left">
              <h1>CONOCÉ NUESTRO PUEBLO</h1>
              <div className="linea-deco"></div>
              <p className="bajada-titulo">
                Recorré nuestra página para descubrir todo lo que ofrece nuestra localidad.
              </p>
            </div>
          </div>

          <div className="cards-expandibles-container">
            
            {/* CARD 1: Nuestra Historia */}
            <div className="card-wrapper" data-aos="fade-up" data-aos-delay="100">
                <div 
                    className={`card-expandible ${activeCard === 0 ? 'active' : ''}`} 
                    onClick={() => toggleCard(0)}
                >
                  <div className="card-visible">
                    <h3>Nuestra Historia</h3>
                    <span className="icon-indicator">+</span>
                  </div>
                  <div className="card-hidden">
                    <p>
                      Fundada formalmente en 1881 por José María Crespo y colonizada por Christian Claus, Progreso nació con una vitalidad asombrosa. Para 1883, la colonia ya se consideraba "ocupada y sembrada", un logro atípico por su rapidez. El pueblo se forjó como un verdadero crisol de razas, recibiendo oleadas de inmigrantes italianos, alemanes y suizos que, junto a las familias criollas, transformaron el monte en tierras productivas. Desde aquel primer molino harinero en 1884 hasta la llegada del ferrocarril en 1888, cada paso marcó el carácter resiliente de nuestra comunidad. Actualmente es un pueblo de 2775 habitantes segun el censo de 2022.
                    </p>
                  </div>
                </div>
            </div>

            {/* CARD 2: Perfil Productivo */}
            <div className="card-wrapper" data-aos="fade-up" data-aos-delay="200">
                <div 
                    className={`card-expandible ${activeCard === 1 ? 'active' : ''}`} 
                    onClick={() => toggleCard(1)}
                >
                  <div className="card-visible">
                    <h3>Perfil Productivo</h3>
                    <span className="icon-indicator">+</span>
                  </div>
                  <div className="card-hidden">
                    <p>
                      Nuestra economía se basa en la agricultura y la ganadería, siendo 
                      la cuenca lechera una de las más importantes de la región. 
                      Un hito fundamental fue la llegada del cooperativismo en 1937, que trajo prosperidad y estabilidad a los productores locales. Hoy, esa herencia se traduce en un sector agroindustrial tecnificado y un sector urbano dinámico. Contamos con industrias locales que agregan valor a nuestra producción.
                      En la zona urbana se desarrollan pymes dedicadas a elaboración y venta de alimentos, maderas, metalurgia, alimentos balanceados, calzado, aberturas, comercios y servicios tercerizados.
                    </p>
                  </div>
                </div>
            </div>

            {/* CARD 3: Ubicación Geográfica */}
            <div className="card-wrapper" data-aos="fade-up" data-aos-delay="300">
                <div 
                    className={`card-expandible ${activeCard === 2 ? 'active' : ''}`} 
                    onClick={() => toggleCard(2)}
                >
                  <div className="card-visible">
                    <h3>Ubicación Geográfica</h3>
                    <span className="icon-indicator">+</span>
                  </div>
                  <div className="card-hidden">
                    <p>
                      Progreso es una comuna argentina ubicada en el Departamento Las Colonias, Provincia de Santa Fe. Se ubica en el centro geográfico de la provincia, a 75 km al noroeste de la capital provincial y a 45 km al norte de la ciudad de Esperanza, cabecera del departamento Las Colonias.
                      La línea vertebral de Progreso es la RP80-S, que por el este, a 7 km, se une a la RP4 (Laguna Paiva – San Cristóbal), que a la altura de Nelson conecta con la RN11 (Rosario – Clorinda, Formosa). Por el oeste se une a la RP62, que a la altura de Sunchales conecta con la RN34 (Rosario – Prof. Salvador Mazza, Salta).
                      A 3 km al este del pueblo por la ruta RP80-S encontramos el Arroyo Cululu.
                    </p>
                  </div>
                </div>
            </div>

          </div>

          <div className="simbolos-patrios" data-aos="fade-up">
            <div className="simbolo-item">
               <img src="/resources/BanderaProgreso.webp" alt="Bandera de Progreso" onError={(e) => e.target.src='/resources/bandera.png'} />
               <h4>Nuestra Bandera</h4>
            </div>
            <div className="simbolo-item">
               <img src="/resources/escudoProgreso.png" alt="Escudo de Progreso" />
               <h4>Nuestro Escudo</h4>
            </div>
          </div>

        </div>
      </section>

      <section className="espaciosPublicos" id="espaciosPublicos">
        <EspaciosPublicos />
      </section>

      <section className="datosUtiles" id="datosUtiles">
        <div className="datosUtiles__wrap">
          <h2 className="datosUtiles__title">Datos y Teléfonos Útiles</h2>
          
          <div className="datosUtiles__grid">
            
            {/* GRUPO 1: COMUNA Y SERVICIOS (Sin cambios) */}
            <div className="datosUtiles__grupo">
              <h3 className="datosUtiles__grupoTitle">🏛️ Administración y Servicios</h3>
              <div className="datosUtiles__item">
                  <strong>Comuna de Progreso:</strong><br/>
                  <a className="datosUtiles__link" href="tel:+543497488032">03497-488032</a> / <a className="datosUtiles__link" href="tel:+543497488193">488193</a><br/>
                  Cel: <a className="datosUtiles__link" href="tel:+5493497402141">3497-402141</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Agua potable:</strong><br/> <a className="datosUtiles__link" href="tel:+543497488115">03497-488115</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Correo Argentino:</strong><br/> <a className="datosUtiles__link" href="tel:+543497488228">03497-488228</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Centro emisor de licencias:</strong><br/> <a className="datosUtiles__link" href="tel:+5493497412598">03497-412598</a>
              </div>
            </div>

            {/* GRUPO 2: SALUD Y SEGURIDAD (Estandarizado) */}
            <div className="datosUtiles__grupo">
              <h3 className="datosUtiles__grupoTitle">🚑 Salud y Seguridad</h3>
              <div className="datosUtiles__item">
                <strong>SAMCo:</strong><br/> <a className="datosUtiles__link" href="tel:+543497488448">03497-488448</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Complejo "María Auxiliadora":</strong><br/> <a className="datosUtiles__link" href="tel:+543497488756">03497-488756</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Bomberos Voluntarios:</strong><br/> <a className="datosUtiles__link" href="tel:+543497414084">03497-414084</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Subcomisaría Quinta:</strong><br/> <a className="datosUtiles__link" href="tel:+543497488137">03497-488137</a>
              </div>
            </div>

            {/* GRUPO 3: BANCOS Y JUSTICIA (Estandarizado) */}
            <div className="datosUtiles__grupo">
              <h3 className="datosUtiles__grupoTitle">⚖️ Bancos y Justicia</h3>
              <div className="datosUtiles__item">
                <strong>Nuevo Banco de Santa Fe:</strong><br/> <a className="datosUtiles__link" href="tel:+543497488235">03497-488235</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Banco Nación:</strong><br/> <a className="datosUtiles__link" href="tel:+543497488091">03497-488091</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Poder Judicial:</strong><br/> <a className="datosUtiles__link" href="tel:+543497488181">03497-488181</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Juzgado de Faltas:</strong><br/> <a className="datosUtiles__link" href="tel:+543497488032">03497-488032</a> (Int. 34)
              </div>
            </div>

            {/* GRUPO 4: EDUCACIÓN */}
            <div className="datosUtiles__grupo">
              <h3 className="datosUtiles__grupoTitle">🎓 Educación</h3>
              
              <div className="datosUtiles__item">
                <strong>E.E.S.O. Nº253 "Mariano Moreno":</strong><br/>
                <a className="datosUtiles__link" href="tel:+543497488387">03497-488387</a><br/>
                <a className="datosUtiles__email" href="mailto:sec253_progreso@santafe.edu.ar">sec253_progreso@santafe.edu.ar</a>
              </div>
              
              <div className="datosUtiles__item">
                <strong>Escuela Primaria Nº341 "José María Paz":</strong><br/>
                <a className="datosUtiles__link" href="tel:+543497488159">03497-488159</a><br/>
                <a className="datosUtiles__email" href="mailto:prim341_progreso@santafe.edu.ar">prim341_progreso@santafe.edu.ar</a>
              </div>
              
              <div className="datosUtiles__item">
                <strong>Jardín de Infantes Nº131 "Martín de la Peña":</strong><br/>
                <a className="datosUtiles__link" href="tel:+543497488242">03497-488242</a><br/>
                <a className="datosUtiles__email" href="mailto:jardin131_progreso@santafe.edu.ar">jardin131_progreso@santafe.edu.ar</a>
              </div>

              {/* ESCUELAS RURALES */}
              <div className="datosUtiles__item">
                <strong>Escuela Rural Nº342 "Tomás Godoy Cruz" (Sur):</strong><br/>
                Fijo: <a className="datosUtiles__link" href="tel:+543497488217">03497-488217</a><br/>
                Cel: <a className="datosUtiles__link" href="tel:+5493424363405">(0342) 154363405</a><br/>
                <a className="datosUtiles__email" href="mailto:prim342_progreso@santafe.edu.ar">prim342_progreso@santafe.edu.ar</a>
              </div>
              
              <div className="datosUtiles__item">
                <strong>Escuela Rural Nº1183 "Brigadier Estanislao López" (Norte):</strong><br/>
                Cel: <a className="datosUtiles__link" href="tel:+5493497535442">(03497) 15535442</a><br/>
                <a className="datosUtiles__email" href="mailto:prim1183_progreso@santafe.edu.ar">prim1183_progreso@santafe.edu.ar</a>
              </div>
            </div>

            {/* GRUPO 5: CULTURA Y DEPORTE (CORREGIDO) */}
            <div className="datosUtiles__grupo">
              <h3 className="datosUtiles__grupoTitle">🎭 Cultura y Sociedad</h3>
              <div className="datosUtiles__item">
                <strong>Museo Comunal:</strong><br/>
                <a className="datosUtiles__link" href="tel:+543497483427">483427</a> / <a className="datosUtiles__link" href="tel:+543497483648">483648</a><br/>
                <a className="datosUtiles__email" href="mailto:museocomunalprogreso@gmail.com">museocomunalprogreso@gmail.com</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Biblioteca "María Emilia Divo":</strong><br/>
                <a className="datosUtiles__link" href="tel:+543497687972">03497-687972</a><br/>
                <a className="datosUtiles__email" href="mailto:bibliotecapopularmed@hotmail.com">bibliotecapopularmed@hotmail.com</a>
              </div>
              {/* AHORA ESTOS USAN LA MISMA ESTRUCTURA */}
              <div className="datosUtiles__item">
                <strong>Casa de la Cultura:</strong><br/>
                <a className="datosUtiles__link" href="tel:+543497488231">03497-488231</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Sociedad Italiana:</strong><br/>
                <a className="datosUtiles__link" href="tel:+543497488483">03497-488483</a><br/>
                <a className="datosUtiles__email" href="mailto:sociedaditalianaprogreso@hotmail.com">sociedaditalianaprogreso@hotmail.com</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Club San Martín:</strong><br/>
                <a className="datosUtiles__link" href="tel:+543497488733">03497-488733</a>
              </div>
              <div className="datosUtiles__item">
                <strong>Parroquia Inmaculada Concepción:</strong><br/>
                <a className="datosUtiles__link" href="tel:+543497488457">03497-488457</a>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="plano" id="plano">
        <h2 className='tituloPlano'>Plano</h2>
        <div className='contenedorPlano'>
          <img src="/resources/plano.png" alt="plano" />
        </div>
        <p className="planoFuente">
          Encontralo en: <a className="planoLink" href="https://www.santafe.gov.ar/ipecinformes/uploads/planta/PROGRESO_A2H.pdf" target="_blank" rel="noreferrer">PROGRESO_A2H.pdf</a>
        </p>
      </section>
      
    </div>
  );
};

export default Informacion;